import styled, { css } from 'styled-components';
import { key, palette } from 'styled-theme';

import { media } from '../../../helper/styleHelper';
import { Label } from '../../../Components/uielements';

export const StyledNavBar = styled.div`
  position: fixed;
  height: 70px;
  background: ${palette('background', 0)};
  top: 0;
  z-index: 999;
  width: 100%;
  color: ${palette('text', 1)};
  border-bottom: 1px solid ${palette('border', 0)};

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: space-between;

  ${media.xl`
    height: 50px;
    font-size: ${key('sizes.vxxlFont.16px', '16px')};
  `}

  ${media.xlr`
    height: 70px;
    font-size: ${key('sizes.xlrFont.normal', '14px')};
  `}

  ${media.xxl`
    height: 75px;
    font-size: ${key('sizes.vxxlFont.16px', '16px')};
  `}
`;

export const NavBarLeft = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  width: fit-content;
  ${(props) =>
    props.isPartner
      ? css``
      : css`
          gap: ${key('sizes.gutter.tiny', '10px')};
        `}
`;

export const NavBarLeftLogo = styled.img`
  width: 192px;
  height: 45px;
  margin-left: 30px;
`;

export const NavBarRight = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  width: fit-content;
  padding: 0 ${key('sizes.gutter.small', '30px')} 0 0;
  gap: ${key('sizes.gutter.smaller', '20px')};

  ${media.lg`
    padding: 0 ${key('sizes.gutter.tiny', '12px')} 0 0;
    gap: ${key('sizes.gap.tiny', '10px')};
  `}
`;

export const NavBarLinkRight = styled.li`
  cursor: pointer;

  ${(props) =>
    props?.isShowIcon
      ? css`
          display: grid;
          grid-auto-flow: column;
          align-items: center;
          gap: ${key('sizes.gutter.tiny', '10px')};
        `
      : css`
          display: block;
        `}
`;

export const NavBarIconContainer = styled.span`
  display: flex;
  gap: ${key('sizes.gap.tiny', '5px')};
  justify-content: center;
  align-items: center;
  font: normal normal 15px/14px Space Grotesk Regular;
  ${(props) =>
    props?.isAcitveTab
      ? css`
          color: ${palette('active', 0)};
        `
      : css`
          color: ${palette('white', 0)};
        `}
`;

export const UserDropDownContainer = styled.div`
  cursor: pointer;
  position: relative;

  ${(props) =>
    props?.isShowIcon
      ? css`
          display: grid;
          grid-auto-flow: column;
          align-items: center;
          gap: ${key('sizes.gutter.tiny', '10px')};
        `
      : css`
          display: block;
        `}

  ${(props) =>
    props?.isAcitveTab &&
    css`
      color: ${palette('active', 0)};
    `}

  ${(props) =>
    props?.isDropDown
      ? css`
          grid-auto-flow: column;
          gap: ${key('sizes.gutter.tiny', '10px')};
        `
      : css``}
`;

export const NavItemRow = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
`;

export const NavItem = styled.div`
  position: relative;
  height: 54px;
  display: grid;
  align-items: center;
  cursor: pointer;
  ${media.xxl`
  height: 60px;
  `};
  ${media.vxxl`
  height: 60px;
  `};

  ${(props) =>
    props?.isDropDown
      ? css`
          grid-auto-flow: column;
          gap: ${key('sizes.gutter.tiny', '10px')};
        `
      : css``}

  ${(props) =>
    props.isPartner
      ? css`
          padding: 6px;
          ${media.xxl`
            padding: 8px;
          `};
        `
      : css`
          padding: ${key('sizes.gutter.tiny', '8px')} ${key('sizes.gutter.custom', '15px')};
        `}
`;

export const NavBarDropDown = styled.div`
  position: absolute;
  top: 75px;
  width: 207px;
  background: ${palette('background', 0)};
  box-shadow: 0px 6px 16px ${palette('shadow', 2)};
  border-radius: 0px 0px 4px 4px;
  ${media.xxl`
    top: 80px;
  `};
  ${media.vxxl`
    top: 80px;
  `};
`;

export const NavBarDropDownRow = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  cursor: pointer;
  /* justify-content: space-between; */
  padding: ${key('sizes.gutter.tiny', '10px')} ${key('sizes.gutter.smaller', '20px')} 20px;
`;

export const UserDropDown = styled.div`
  position: absolute;
  width: 340px;
  right: 0px;
  overflow-y: auto;
  top: 72.5px;
  max-height: 400px;

  background: ${palette('background', 0)};
  border-radius: 0px 0px 4px 4px;
  border: 1px solid ${palette('border', 0)};
  border-top-width: 0px;

  ${media.xxl`
    top: 75.5px;
  `};

  ${media.vxxl`
    top: 76.5px;
  `};

  ${media.md`
    width: 280px;
  `};
`;

export const UserDropDownRow = styled.div`
  padding: ${key('sizes.gutter.tiny', '10px')} ${key('sizes.gutter.smaller', '20px')};

  display: grid;
  grid-auto-flow: column;
  align-items: center;

  &:hover {
    background: ${palette('background', 8)};
  }
`;

export const LoutoutRow = styled.div`
  position: sticky;
  bottom: 0;
  display: grid;
  grid-auto-flow: column;
  gap: 5px;
  align-items: center;
  text-align: center;
  justify-content: center;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 15px;
  background: ${palette('background', 0)};
  width: 100%;
  border-top: 0.2px solid ${palette('border', 0)};
`;

export const NavBarDropDownRowLeft = styled.div`
  display: grid;
  align-items: center;
  gap: ${key('sizes.gutter.small', '10px')};
`;

// userRoleSwitcher css
export const UserRoleSwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${key('sizes.gap.normal', '25px')};
  cursor: pointer;
  position: relative;
`;

export const UserName = styled(Label)`
  font: normal normal 18px/16px Space Grotesk Regular;
  cursor: pointer;
`;

export const CompanyFilterTitle = styled(Label)`
  font: normal normal 14px/14px Space Grotesk Regular;
  cursor: pointer;
`;

export const UserRole = styled(Label)`
  font: normal normal 14px/14px Space Grotesk Regular;
  cursor: pointer;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${media.xxl`
      max-width: max-content;
  `};
`;

export const ModalWrapper = styled.div`
  display: grid;
  align-items: center;
  gap: ${key('sizes.gap.big', '40px')};
  padding: 10px 20px;
  margin-bottom: ${key('sizes.gutter.smaller', '20px')};
  min-width: 300px;
`;

// selectCompany com css
export const FilterCompanyContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${key('sizes.gap.normal', '25px')};
  cursor: pointer;
`;

export const FilterCompanyWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 20px;
  border-radius: 4px;
  border: 1px solid ${palette('border', 1)};
  padding: 5px 10px;
  justify-content: space-between;
  align-items: center;
`;

export const CompanySelectorModalWrapper = styled.div`
  display: grid;
  align-items: center;
  gap: ${key('sizes.gap.normal', '25px')};
  padding: 10px 20px;
  margin-bottom: ${key('sizes.gutter.smaller', '20px')};
  min-width: 300px;
`;

export const SelectorWrapper = styled.div``;

export const SelectorLable = styled(Label)`
  font: normal normal 18px/14px Space Grotesk Regular;
  cursor: pointer;
  ${(props) =>
    props.isSeleted &&
    css`
      color: ${palette('text', 4)};
    `}
`;
export const SelectorModalPaginationWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: center;
  gap: ${key('sizes.gutter.normal', '25px')};
  padding: 0px 20px 20px;
`;

export const PaginationLeft = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: ${key('sizes.gap.tiny', '5px')};
  align-items: center;
  cursor: pointer;
`;

export const PaginationRight = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: ${key('sizes.gap.tiny', '5px')};
  align-items: center;
  cursor: pointer;
`;

export const PaginationTitle = styled(Label)`
  font: normal normal 14px/14px Space Grotesk Regular;
`;
export const PaginationButton = styled(Label)`
  border: 1px solid ${palette('gray', 2)};
  padding: 0px 6px;
  ${(props) =>
    props?.disabled
      ? css`
          color: ${palette('gray', 2)} !important;
        `
      : css``}
`;

export const TooltipWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  column-gap: ${key('sizesV3.gutter.5', '5px')};
  position: relative;
`;

export const Tag = styled(Label).attrs({ color: 'dark' })`
  font-size: 11px !important;
  padding: 5px;
  background-color: ${palette('background', 2)};
  border-radius: 20px;
  padding: 5px 10px;
  margin-left: 5px;
`;

/* ---------------------------------------------------------------------- */
/* Mobile / tablet responsive drawer                                      */
/* ---------------------------------------------------------------------- */

export const MobileHamburger = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  margin-left: 12px;
  svg {
    width: 30px;
    height: 30px;
    color: ${palette('active', 0)};
  }

  /* Show on both tablet and mobile breakpoints */
  ${media.lg`
    display: block;
  `}
`;

export const MobileOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1200;
`;

export const MobileMenu = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 300px;
  max-width: 85vw;
  height: 100vh;
  background: ${palette('background', 0)};
  box-shadow: 6px 0 20px ${palette('shadow', 2)};
  z-index: 1300;
  display: grid;
  grid-auto-rows: auto 1fr auto;
`;

export const MobileMenuHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid ${palette('border', 0)};
`;

export const MobileNavList = styled.div`
  padding: 12px 10px;
  overflow-y: auto;
  display: grid;
  gap: 4px;
  align-content: start;
`;

/* Wraps a single top-level item + its (optional) accordion sub list */
export const MobileNavItem = styled.div`
  border-radius: 8px;
  overflow: hidden;
  background: ${(props) => (props.isExpanded ? palette('background', 8) : 'transparent')};
  transition: background 0.15s ease;
`;

export const MobileNavItemHeader = styled.div`
  padding: 14px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font: normal normal 15px/16px Space Grotesk Regular;
  color: ${(props) => (props.isActive ? palette('active', 0) : palette('white', 0))};

  &:hover {
    background: ${palette('background', 8)};
  }
`;

export const MobileChevron = styled.span`
  display: flex;
  align-items: center;
  transform: ${(props) => (props.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease;

  svg {
    width: 14px;
    height: 14px;
  }
`;

/* Accordion body for sub-options (records / admin etc.) */
export const MobileSubNavList = styled.div`
  display: grid;
  gap: 2px;
  max-height: ${(props) => (props.isExpanded ? '600px' : '0px')};
  opacity: ${(props) => (props.isExpanded ? 1 : 0)};
  overflow: hidden;
  padding: ${(props) => (props.isExpanded ? '2px 8px 10px' : '0px 8px')};
  transition:
    max-height 0.25s ease,
    opacity 0.2s ease,
    padding 0.2s ease;
`;

export const MobileSubNavItem = styled.div`
  padding: 11px 14px;
  margin-left: 10px;
  border-left: 2px solid ${palette('border', 0)};
  cursor: pointer;
  font: normal normal 14px/16px Space Grotesk Regular;
  color: ${(props) => (props.isActive ? palette('active', 0) : palette('text', 1))};

  &:hover {
    background: ${palette('background', 8)};
    border-left-color: ${palette('active', 0)};
  }
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  margin-bottom: 16px;
  padding: 0 18px;
`;

export const SearchInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #e6b471;
  outline: none;
  font-size: 14px;
  background: transparent;
  color: inherit;

  &::placeholder {
    color: #9a9a9a;
  }

  &:focus {
    border-color: #e6b471;
  }
`;

export const ClearSearchIcon = styled.span`
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: #9a9a9a;
  user-select: none;

  &:hover {
    color: #e6b471;
  }
`;
